import I18n from 'I18n';
import { View } from 'foundations-components/components/View';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import FallbackErrorBanner from '../../../components/common/loading/FallbackErrorBanner';
import { useAddOnsData, useEligibleAddOns } from '../../hooks/add-ons/useAddOnsData';
import { useAddOnsSearch } from '../../hooks/add-ons/useAddOnsSearch';
import { useQueryParamTerm } from '../../utils/urls/appQueryParamUtils';
import { AddOnCard } from './AddOnCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AddOnsList = () => {
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const {
    validAddOns,
    allAddOnApiNames,
    isLoading: eligibleAddOnsLoading,
    hasError
  } = useEligibleAddOns();
  const {
    searchTerm,
    filteredAddOns,
    handleSearchChange,
    showSearchInput
  } = useAddOnsSearch({
    validAddOns
  });
  const {
    allProductDetails,
    inventoryProducts,
    purchaseMotionsMapping,
    allPricingData,
    currencyCode,
    hubspotCreditsData,
    isLoading: dataLoading,
    hasError: dataHasError
  } = useAddOnsData({
    addOnApiNames: allAddOnApiNames
  });
  if (hasError || dataHasError) {
    return /*#__PURE__*/_jsx(FallbackErrorBanner, {});
  }
  if (eligibleAddOnsLoading || dataLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      minHeight: 200,
      size: "md",
      grow: true
    });
  }
  return /*#__PURE__*/_jsxs(View, {
    inlineSize: "700px",
    marginInline: "auto",
    children: [showSearchInput && /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(SearchInput, {
        value: searchTerm,
        onChange: handleSearchChange,
        placeholder: I18n.text('pricingPage.pages.addOns.search.placeholder'),
        marginBlockEnd: "400"
      })
    }), filteredAddOns.map(({
      productApiName,
      titleText,
      descriptionText
    }) => {
      var _allProductDetails$pr, _productDetails$packa, _hubspotCreditsData$q, _hubspotCreditsData$q2, _purchaseMotionsMappi, _purchaseMotions$, _purchaseOptionsData$, _purchaseOptionsData$2, _purchaseOptionsData$3;
      const productDetails = allProductDetails === null || allProductDetails === void 0 || (_allProductDetails$pr = allProductDetails.productsByName) === null || _allProductDetails$pr === void 0 ? void 0 : _allProductDetails$pr[productApiName];
      if (!productDetails) {
        return null;
      }
      const isHubSpotCredits = productDetails.skuCategoryName === 'HUBSPOT_CREDITS';
      const quantityMultiplier = isHubSpotCredits ? (_productDetails$packa = productDetails.packagedQuantitiesMap['HUBSPOT_CREDITS']) !== null && _productDetails$packa !== void 0 ? _productDetails$packa : 1 : 1;
      const ownedProduct = inventoryProducts === null || inventoryProducts === void 0 ? void 0 : inventoryProducts.find(p => p.productApiName === productApiName);
      const ownedQuantity = ownedProduct !== null && ownedProduct !== void 0 && ownedProduct.skuQuantityPurchased ? ownedProduct.skuQuantityPurchased * quantityMultiplier : 0;
      const includedQuantity = isHubSpotCredits ? (_hubspotCreditsData$q = hubspotCreditsData === null || hubspotCreditsData === void 0 || (_hubspotCreditsData$q2 = hubspotCreditsData.quantities['HUBSPOT_CREDITS']) === null || _hubspotCreditsData$q2 === void 0 ? void 0 : _hubspotCreditsData$q2.includedQuantity) !== null && _hubspotCreditsData$q !== void 0 ? _hubspotCreditsData$q : 0 : 0;
      const purchaseMotions = purchaseMotionsMapping === null || purchaseMotionsMapping === void 0 || (_purchaseMotionsMappi = purchaseMotionsMapping.productsByLocationString['MERCH_CARD']) === null || _purchaseMotionsMappi === void 0 || (_purchaseMotionsMappi = _purchaseMotionsMappi.purchaseMotionsByProductApiName[productApiName]) === null || _purchaseMotionsMappi === void 0 ? void 0 : _purchaseMotionsMappi.purchaseMotions;
      const purchaseMotion = (_purchaseMotions$ = purchaseMotions === null || purchaseMotions === void 0 ? void 0 : purchaseMotions[0]) !== null && _purchaseMotions$ !== void 0 ? _purchaseMotions$ : 'TALK_TO_SALES_FALLBACK';
      const purchaseOptionsData = allPricingData === null || allPricingData === void 0 ? void 0 : allPricingData[productApiName];
      const purchaseOption = (_purchaseOptionsData$ = purchaseOptionsData === null || purchaseOptionsData === void 0 || (_purchaseOptionsData$2 = purchaseOptionsData.purchaseOptions) === null || _purchaseOptionsData$2 === void 0 ? void 0 : _purchaseOptionsData$2[queryParamTerm]) !== null && _purchaseOptionsData$ !== void 0 ? _purchaseOptionsData$ : Object.values((_purchaseOptionsData$3 = purchaseOptionsData === null || purchaseOptionsData === void 0 ? void 0 : purchaseOptionsData.purchaseOptions) !== null && _purchaseOptionsData$3 !== void 0 ? _purchaseOptionsData$3 : {})[0];
      return /*#__PURE__*/_jsx(AddOnCard, {
        productApiName: productApiName,
        titleText: titleText,
        descriptionText: descriptionText,
        productDetails: productDetails,
        purchaseMotion: purchaseMotion,
        purchaseOption: purchaseOption,
        ownedQuantity: ownedQuantity,
        includedQuantity: includedQuantity,
        isHubSpotCredits: isHubSpotCredits,
        currencyCode: currencyCode
      }, productApiName);
    })]
  });
};